var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 53,
  height: 46
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "icon-error_svg__a",
  d: "M29.226 2.95 53.24 43.99A2 2 0 0 1 51.514 47H3.487a2 2 0 0 1-1.726-3.01L25.774 2.95a2 2 0 0 1 3.452 0"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon-error_svg__a",
  fill: "#FE768D"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon-error_svg__a",
  fill: "#EA0850"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  transform: "translate(26 19)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.696,
  height: 15.4,
  rx: 1.848
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.848,
  cy: 19.558,
  r: 1.848
})))));
export { SvgIconError as ReactComponent };
export default __webpack_public_path__ + "img/icon-error.7b75ea0043a7f9d93b48df4104bd9ee2.svg";